import React, { useState, useEffect } from "react";
import { CustomCard, CustomCardContent, CustomCardHeaderWithPopover,Divider } from './CustomComponents';
import Plot from 'react-plotly.js';
import { useGraphContext } from '../GraphContext';
import Spinner from "./Spinner";

const Mileage = ({ submitClicked, handleDownload, error}) => {
    const [histogramData, setHistogramData] = useState(null);
    const [boxPlotData, setBoxPlotData] = useState(null);

    const [histogramData_weight, setHistogramData_weight] = useState(null);
    const [heatmapData_weight, setHeatmapData_weight] = useState(null);
    const [loading, setLoading] = useState(true); // Loading state

    const { filters } = useGraphContext();
    console.log('Graph Data',filters)
    useEffect(() => {
        if (filters) {
            setLoading(true);
             // Set loading to true when filters change
            try {
                const parsedFilters = JSON.parse(filters.yearly_mil)

                const boxplot=filters.box.yearly_mileage__km

                // Handle the new structure with both bar chart and heatmap
                if (filters.weight_histo.bar_chart && filters.weight_histo.heatmap) {
                    const weights_bar_chart = JSON.parse(filters.weight_histo.bar_chart);
                    const weights_heatmap = JSON.parse(filters.weight_histo.heatmap);
                    setHistogramData_weight(weights_bar_chart);
                    setHeatmapData_weight(weights_heatmap);
                } else {
                    // Fallback for old structure
                    const weights_histo = JSON.parse(filters.weight_histo);
                    setHistogramData_weight(weights_histo);
                    setHeatmapData_weight(null);
                }

                setHistogramData(parsedFilters);

                setBoxPlotData(boxplot);

                console.log(boxPlotData)
            } catch (error) {          
                console.error('Error parsing JSON:', error);
            } finally {
                setLoading(false); // Set loading to false after data processing
            }
        } else{
            setLoading(false); // Set loading to false after data processing 
        }
    }, [filters]);

    return (
        <div className="KPI_main_div" >
 
        <div>
        <div className="outer_div_title_onTop_of_KPI" style={{ marginTop: '0px' }}>
          <h6 className="title_onTop_of_KPI" >Yearly mileage</h6>
        </div>
  
        <div className="plot_div" >
          <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'Yearly_Mileage_histo'
                    content= {
                    `<ul>
                    <li>This histogram visualizes the distribution of numerical data using bins of 20,000 km each. Each bar represents the absolute count of VINs (vehicles) falling within a specific mileage range, based on your selection on the "Filter" page.</li>
                    
                    <li><b>Metric:</b> This chart displays the absolute yearly mileage per vehicle and year. The year of commissioning and the current year are extrapolated to allow comparison across years.</li>
                    
                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.<br/>
                        Example: A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation.  
                        As a result, the total count in the histogram may exceed the number of "activated vehicles".</li>
                    
                    <li><b>Overlay line chart:</b> A cumulative line graph is layered over the bars to show the relative cumulative distribution of vehicles across mileage bins.</li>
                    </ul>`

                    } 
                    handleDownload={handleDownload}
                    downloadOption="yearly_mileage_histo"
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                <div className="error_message">
                                    <p>Invalid combination - please check your inputs.</p>
                                </div>
                                ) : histogramData ? (
                                    <Plot
                                      data={histogramData.data}
                                      layout={histogramData.layout}
                                      config={{ responsive: true }}
                                      style={{ width: '100%', height: '100%' }}
                                      useResizeHandler={true}
                                      autosize={true}
                                    />
                                ) : null
                            ) : (
                                <div className="no_vehicles_message" >
                                    <p>No vehicle(s) selected - please apply filter</p>
                                </div>
                     )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Boxplot' id= 'Yearly_Mileage_box'
                    content= {
                `<ul>
                <li>A boxplot is a visual tool used to show how numerical data is distributed.</li>
                
                <li><b>Metric:</b> This chart focuses on the absolute yearly mileage per vehicle and year. The year of commissioning and the current year are extrapolated to allow comparison across years.</li>
                
                <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>
                
                <li><b>Visualization:</b> The boxplot shows the distribution of yearly mileage values using five key values:
                    <ul>
                    <li>5th percentile (Min) – the lower extreme of the data</li>
                    <li>25th percentile (Q1) – the lower quartile</li>
                    <li>50th percentile (Median) – the middle value</li>
                    <li>75th percentile (Q3) – the upper quartile</li>
                    <li>95th percentile (Max) – the upper extreme of the data</li>
                    </ul>
                </li>
                
                <li>Boxplots are especially useful for comparing distribution patterns across different years, helping to highlight shifts, trends, or anomalies in vehicle usage over time.</li>
                </ul>`

                    }
                    handleDownload={handleDownload}
                    downloadOption="yearly_mileage__km" 
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : boxPlotData ? (
                                    <Plot
                                      data={boxPlotData.data}
                                      layout={boxPlotData.layout}
                                      config={{ responsive: true }}
                                      style={{ width: '100%', height: '100%' }}
                                      useResizeHandler={true}
                                      autosize={true}
                                    />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                        )}
                </CustomCardContent>
            </CustomCard>
            </div>
          </div>
        </div>
  
        <div style={{ marginTop: '20px'}}>
        <div className="outer_div_title_onTop_of_KPI" >
          <h6 className="title_onTop_of_KPI" >Relative mileage per payload class</h6>
        </div>

        <div className="plot_div" >
          <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Histogram' id= 'weight_bar_chart'
                    content= {
                    `<ul>
                        <li><strong>Definition:</strong> This histogram visualizes the distribution of numerical data using bins of 2 t each. Each bar represents the absolute count of VINs (vehicles) falling within a specific range, based on your selection on the "Filter" page.</li>
                        <li><strong>Metric:</strong> This chart displays the relative mileage per payload class per vehicle and year. It provides insight into how mileage is distributed across different payload classes. As a relative visualization, it allows you to observe patterns—such as the fact that only half as much mileage was driven with a 40-ton payload compared to a 20-ton payload. This suggests that the truck under analysis spent approximately half of its mileage fully loaded, while the other half was driven with little or no load.</li>
                        <li><strong>Counting logic:</strong> If a vehicle operates in multiple years, it is counted once per year and may appear in the same or different bins.</li>
                        <li><strong>Example:</strong> A vehicle sold in 2024 will appear twice—once for 2024 and once for 2025—since it has two years of operation. As a result, the total count in the histogram may exceed the number of "activated vehicles."</li>
                        <li><strong>Aggregation:</strong> This bar chart shows the aggregated relative mileage across all selected years, providing an overall distribution pattern.</li>
                        <li><strong>Note:</strong> Payload information is most accurate for "Long Haul Tractors" - other vehicle types may have deviations in payload information</li>
                        <li><strong>Bin size:</strong> 2 t</li>
                    </ul>`
                    } 
                    handleDownload={handleDownload}
                    downloadOption="weight_histo"
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : histogramData_weight ? (
                                    <Plot
                                      data={histogramData_weight.data}
                                      layout={histogramData_weight.layout}
                                      config={{ responsive: true }}
                                      style={{ width: '100%', height: '100%' }}
                                      useResizeHandler={true}
                                      autosize={true}
                                    />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                    )}
                </CustomCardContent>
            </CustomCard>
            </div>
            <div style={{ flex: 1 }}>
            <CustomCard>
                <CustomCardHeaderWithPopover title='Heatmap' id= 'weight_heatmap'
                    content= {
                    `<ul>
                    <li><b>Disclaimer:</b> Data may be missing for CM4 vehicles due to provision issues. When data is available, this KPI is displayed as intended. The issue has been reported to the respective teams.</li>

                    <li>A heatmap is a visual tool used to show how numerical data is distributed.</li>

                    <li><b>Metric:</b> This chart focuses on the relative mileage per payload class per vehicle and year.</li>

                    <li><b>Counting logic:</b> If a vehicle operates in multiple years, it is present in the respective year bar.</li>

                    <li><b>Visualization:</b> The heatmap shows the distribution of relative mileage per payload class and year. Each cell in the matrix represents the relative mileage for a payload class in a given year.</li>

                    <li>Heatmaps are especially useful for comparing distribution patterns across different years, helping to highlight trends or anomalies in vehicle usage over time.</li>
                    </ul>`

                    }
                    handleDownload={handleDownload}
                    downloadOption="weight_histo" 
                />
                <Divider className="divider" />
                <CustomCardContent>
                    {submitClicked ? (
                        loading ? (
                            <Spinner />
                                ) : error ? (
                                    <div className="error_message">
                                        <p>Invalid combination - please check your inputs.</p>
                                    </div>
                                    ) : heatmapData_weight ? (
                                    <Plot
                                      data={heatmapData_weight.data}
                                      layout={heatmapData_weight.layout}
                                      config={{ responsive: true }}
                                      style={{ width: '100%', height: '100%' }}
                                      useResizeHandler={true}
                                      autosize={true}
                                    />
                                    ) : null
                                ) : (
                                    <div className="no_vehicles_message" >
                                        <p>No vehicle(s) selected - please apply filter</p>
                                    </div>
                        )}
                </CustomCardContent>
            </CustomCard>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default Mileage;

{/* <div sx={{ flex: '0 0 50%', minWidth: '300px' }} */}


